import * as types from '../mutation-types'
import { API } from '../../api'
import { COMMENT_DATA_MANAGER, BASE_DATA_MANAGER, FATE_DATA_MANAGER } from '../../data'
import FateFortuneStore from '../plugins/fatefortune'

export default {
    namespaced: true,
    modules: {
        fatefortune: FateFortuneStore
    },
    state: {
        hideName: false,
        canBeEdited: true,
        otherSaved: false,
        getPiPanData: false,
        pipanConfig: {},
        pipanInfo: {},
        pipanInfoBase: {},
        pipanInfoList: {},
        shareCode: {},
        detailInfo: {},
        activeNames: [],
        showChange: false,
        curChangeType: '',
        curChangeList: [],
        fateText: '',
        situationText: '',
        strongText: '',
        medicineList: [],
        curMedicineItem: {},
        showCustom: false,
        dayunLiunianList: [],
        activeDaYunNames: [],
        activeLiuNianNames: [],
        curActiveName: '',
        curSubTab: 0,
        fromMyComment: false,
        fromOtherComment: false,
        fromCommentFormRead: false,
        otherShareTitle: '',
        otherShareCode: '',
        showBottomBar: true,
    },
    getters: {},
    mutations: {
        [types.COMMENT_INIT_DATA](state, params) {
            state.curSubTab = 0;
            state.detailInfo = params.detailData;
            state.fromMyComment = true;
            // 如果已经编辑过了就默认浏览模式
            if(params.detailData.pipan == 1) {
                state.canBeEdited = false;
            }

            if(state.getPiPanData) { return; }
            API.getPiPanDataNew({
                id: params.detailData.id
            }, function(data){
                console.log('获取批盘信息-------', params.detailData, params.detailData.id, data)
            
                state.getPiPanData = true;
                state.pipanConfig = data.config;
                state.pipanInfoBase = data.info.base;
                state.pipanInfoList = data.info.list;
                state.shareCode = data.shareCode;

                // 初始化基础数据:命局，强弱，用药，类型
                AppFate.$store.dispatch('base/initSituationData', data.config.situation)
                AppFate.$store.dispatch('base/initStrongData', data.config.strong)
                AppFate.$store.dispatch('base/initMedicineData', data.config.medicine)
                AppFate.$store.dispatch('base/initTypeData', data.config.type)
                setTimeout(() => {
                    // 命局类型和强弱
                    state.fateText = FATE_DATA_MANAGER.getFateTextByData(params.detailData);
                    var situationList = AppFate.$store.state.base.situationList;
                    state.situationText = BASE_DATA_MANAGER.getBaseDataTextById(situationList, data.info.base ? data.info.base.situation : 0);
                    var strongList = AppFate.$store.state.base.strongList;
                    state.strongText = BASE_DATA_MANAGER.getBaseDataTextById(strongList, data.info.base ? data.info.base.strong : 0);

                    // 用药数据
                    var medicineList = AppFate.$store.state.base.medicineList;
                    var baseList = [].concat(medicineList[0]).concat(medicineList[1]);
                    var medicine = data.info.base && data.info.base.medicine != '' ? JSON.parse(data.info.base.medicine) : [];
                    if(medicine.length == 0) {
                        state.pipanInfo.medicine = JSON.stringify(COMMENT_DATA_MANAGER.getBaseMedicineListByList(baseList));
                        state.medicineList = COMMENT_DATA_MANAGER.getMedicineListByList(baseList);
                    }else {
                        state.medicineList = COMMENT_DATA_MANAGER.getMedicineListByList(medicine);
                    }

                    // 初始化批盘页:大运流年数据列表
                    // var fortuneList = AppFate.$store.state.minifatefortune.fortuneListData;
                    // var typeList = state.pipanConfig.type.concat([['吉', '凶', '平', '吉藏凶', '凶藏吉']]);
                    // state.dayunLiunianList = COMMENT_DATA_MANAGER.getDayunLiunianListByList(fortuneList, typeList, data.info.list);

                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }, 100);
            })
        },
        [types.COMMENT_INIT_SHARE_DATA](state, params) {
            console.log('types.COMMENT_INIT_SHARE_DATA----', params)
            state.canBeEdited = false;

            // 初始化迷你命盘数据
            state.detailInfo = params.detailData;
            // 暂存命盘数据
            AppFate.$store.state.detail.personInfo = params.detailData;
            AppFate.$store.dispatch('minifatefortune/initCommentMiniFateFortune', params.detailData);

            // 命盘数据
            state.pipanInfoBase = params.pipanData.base;
            state.pipanInfoList = params.pipanData.list;
            // 打开分享的批盘，默认展开所有的数据
            state.activeNames = ['base', 'situation', 'medicine', 'big', 'other', 'suggest'];
            setTimeout(() => {
                state.fateText = FATE_DATA_MANAGER.getFateTextByData(params.detailData);

                // 命局类型和强弱
                state.situationText = params.pipanData.base.situation;
                state.strongText = params.pipanData.base.strong;

                // 用药数据
                var medicine = params.pipanData.base && params.pipanData.base.medicine != '' ? JSON.parse(params.pipanData.base.medicine) : [];
                state.medicineList = medicine.length > 0 ? COMMENT_DATA_MANAGER.getMedicineListByList(medicine) : [];
            
                // 初始化批盘页:大运流年数据列表
                // var fortuneList = AppFate.$store.state.minifatefortune.fortuneListData;
                // state.dayunLiunianList = COMMENT_DATA_MANAGER.getDayunLiunianListByList(fortuneList, [], params.pipanData.list);

                // // 展开有数据的内容
                // var activeNames = COMMENT_DATA_MANAGER.getDayunLiunianListActiveNames(state.dayunLiunianList);
                // state.activeDaYunNames = activeNames.dayun;
                // state.activeLiuNianNames = activeNames.liunian;
            }, 100);
        },
        [types.COMMENT_INIT_OTHER_DATA](state, params) {
            console.log('types.COMMENT_INIT_OTHER_DATA-----', params)
            state.canBeEdited = false;
            state.curSubTab = 4;
            state.fromOtherComment = true;

            // 初始化迷你命盘数据
            state.detailInfo = params.detailData;
            // 暂存命盘数据
            AppFate.$store.state.detail.personInfo = params.detailData;
            AppFate.$store.dispatch('minifatefortune/initCommentMiniFateFortune', params.detailData);
            
            // 命盘数据
            state.pipanInfoBase = params.pipanData.base;
            state.pipanInfoList = params.pipanData.list;
            // 打开分享的批盘，默认展开所有的数据
            state.activeNames = ['base', 'situation', 'medicine', 'big', 'other', 'suggest'];
            state.fateText = FATE_DATA_MANAGER.getFateTextByData(params.detailData);
            // 命局类型和强弱
            state.situationText = params.pipanData.base.situation;
            state.strongText = params.pipanData.base.strong;
            // 用药数据
            var medicine = params.pipanData.base && params.pipanData.base.medicine != '' ? JSON.parse(params.pipanData.base.medicine) : [];
            state.medicineList = medicine.length > 0 ? COMMENT_DATA_MANAGER.getMedicineListByList(medicine) : [];
            
            // 初始化批盘页:大运流年数据列表
            // var fortuneList = AppFate.$store.state.minifatefortune.fortuneListData;
            // state.dayunLiunianList = COMMENT_DATA_MANAGER.getDayunLiunianListByList(fortuneList, [], params.pipanData.list);

            // // 展开有数据的内容
            // var activeNames = COMMENT_DATA_MANAGER.getDayunLiunianListActiveNames(state.dayunLiunianList);
            // state.activeDaYunNames = activeNames.dayun;
            // state.activeLiuNianNames = activeNames.liunian;
        },
        [types.COMMENT_INIT_EMBEDDED_DATA](state, params) {
            state.curSubTab = 0;
            state.detailInfo = params.detailData;
            state.fromMyComment = true;
            // 如果已经编辑过了就默认浏览模式
            if(params.detailData.pipan == 1) {
                state.canBeEdited = false;
            }

            if(state.getPiPanData) { return; }
            API.getPiPanData({
                id: params.detailData.id
            }, function(data){
                console.log('获取批盘信息-------', params.detailData, params.detailData.id, data)

                state.getPiPanData = true;
                state.pipanInfo = data.info;
                state.pipanConfig = data.config;
                state.shareCode = data.shareCode;

                // 初始化基础数据:命局，强弱，用药，类型
                AppFate.$store.dispatch('base/initSituationData', data.config.situation)
                AppFate.$store.dispatch('base/initStrongData', data.config.strong)
                AppFate.$store.dispatch('base/initMedicineData', data.config.medicine)
                AppFate.$store.dispatch('base/initTypeData', data.config.type)
                setTimeout(() => {
                    // 命局类型和强弱
                    state.fateText = FATE_DATA_MANAGER.getFateTextByData(params.detailData);
                    var situationList = AppFate.$store.state.base.situationList;
                    state.situationText = BASE_DATA_MANAGER.getBaseDataTextById(situationList, data.info.situation);
                    var strongList = AppFate.$store.state.base.strongList;
                    state.strongText = BASE_DATA_MANAGER.getBaseDataTextById(strongList, data.info.strong);

                    // 用药数据
                    var medicineList = AppFate.$store.state.base.medicineList;
                    var baseList = [].concat(medicineList[0]).concat(medicineList[1]);
                    var medicine = data.info.medicine && data.info.medicine != '' ? JSON.parse(data.info.medicine) : [];
                    if(medicine.length == 0) {
                        state.pipanInfo.medicine = JSON.stringify(COMMENT_DATA_MANAGER.getBaseMedicineListByList(baseList));
                        state.medicineList = COMMENT_DATA_MANAGER.getMedicineListByList(baseList);
                    }else {
                        state.medicineList = COMMENT_DATA_MANAGER.getMedicineListByList(medicine);
                    }

                    // 初始化批盘页:大运流年数据列表
                    var fortuneList = AppFate.$store.state.minifatefortune.fortuneListData;
                    state.dayunLiunianList = state.pipanInfo.big ? COMMENT_DATA_MANAGER.getDayunLiunianListByList(fortuneList, state.pipanConfig.type, state.pipanInfo.big) : [];

                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }, 100);
            })
        },
        [types.COMMENT_UPDATE_CHANGE_LIST](state, type) {
            switch(type) {
                case 'situation':
                    state.curChangeList = AppFate.$store.state.base.situationList;
                    break;
                case 'strong':
                    state.curChangeList = AppFate.$store.state.base.strongList;
                    break;
                case 'medicine':
                    state.curChangeList = AppFate.$store.state.base.medicineList;
                    break;
                default:
                    break;
            }
        },
        [types.COMMENT_UPDATE_ACTIVE_NAMES](state, params) {
            console.log('types.COMMENT_UPDATE_ACTIVE_NAMES------', params, state.activeNames)
            // 全部都没有展开的情况下要展开大运流年
            if(state.activeNames.length == 0) {
                state.activeNames = ['big'];
            }else{
                if(state.activeNames.indexOf('big') == -1) {
                    state.activeNames.push('big');
                }
            }
            
            state.activeDaYunNames.splice(0);
            state.activeLiuNianNames.splice(0);
            var curName = '';
            var listPromise = new Promise(function(resolve, reject) {
                params.listData.forEach((data, index) => {
                    console.log('data-------', data)
                    if(data.type == 'dayun') {
                        curName = data.key;
                        state.activeDaYunNames.push(curName);
                    }else if(data.type == 'liunian') {
                        let dayunIndex = params.listData[0].key.slice(3);
                        curName = data.type+data.key+'_'+dayunIndex;
                        state.activeLiuNianNames.push(curName); 
                    }
                    // 遍历到最后一项完成
                    if(index == (params.listData.length - 1)){
                        resolve();
                    }
                });
            });
            listPromise.then(() => {
                // 重置列表滚动位置:要在滚动完之后再设置才准确 Todo:优化
                setTimeout(() => {
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb(curName);
                    }
                    if(!state.canBeEdited) {
                        state.fromCommentFormRead = true;
                    }
                }, 500);
            });
            listPromise.catch(() => {
                console.log('获取大运流年数据失败');
            });
            // console.log('activeNames------', state.activeDaYunNames, state.activeLiuNianNames)
        },
        [types.COMMENT_SUBMIT_UPDATE_PIPAN](state, params) {

            var newParams = Object.assign({
                id: state.detailInfo.id,
                info: JSON.stringify(params.info)
            });
            console.log('types.COMMENT_SUBMIT_UPDATE_PIPAN------', params, newParams);
            API.updatePiPan(newParams, function(data){
                
                if(data.ret) {

                    // 根据不同的数据类型来更新数据:基础,其他分析,建议
                    var infoData = params.info;
                    if(infoData['base'] || infoData['base'] == '') {
                        state.pipanInfo.base = infoData['base'];
                    }
                    if(infoData['other'] || infoData['other'] == '') {
                        state.pipanInfo.other = infoData['other'];
                    }
                    if(infoData['suggest'] || infoData['suggest'] == '') {
                        state.pipanInfo.suggest = infoData['suggest'];
                    }

                    // situation, strong, medicine
                    if(infoData['situation']) {
                        state.pipanInfo.situation = infoData['situation'];
                        state.situationText = params.text;
                        AppFate.$store.dispatch('detail/updateSituationString', infoData['situation']);
                        AppFate.$store.dispatch('record/updateRecordListSituation', {
                            id: state.detailInfo.id,
                            situation: infoData['situation']
                        });
                    }
                    if(infoData['strong']) {
                        state.pipanInfo.strong = infoData['strong'];
                        state.strongText = params.text;
                        AppFate.$store.dispatch('detail/updateStrongString', infoData['strong']);
                        AppFate.$store.dispatch('record/updateRecordListStrong', {
                            id: state.detailInfo.id,
                            strong: infoData['situation']
                        });
                    }

                    // 更新列表数据的批盘状态
                    AppFate.$store.dispatch('record/updateRecordListPipanStatus', state.detailInfo.id);
                    AppFate.$store.dispatch('detail/updateDetailPipanStatus');

                    setTimeout(() => {
                        // 执行回调函数:更新UI层交互
                        if(params.cb && typeof(params.cb) == 'function') {
                            params.cb();
                        }
                    }, 100);
                }
            })
        },
        [types.COMMENT_SUBMIT_UPDATE_PIPAN_MEDICINE](state, params) {
            console.log('types.COMMENT_SUBMIT_UPDATE_PIPAN_MEDICINE------', params)
            var medicine = state.pipanInfo.medicine == '' ? [] : JSON.parse(state.pipanInfo.medicine), 
                newParams = {id: state.detailInfo.id};
            // 更新用药数据:用药类型:有用药数据的时候
            if(params['medicineItem']) {
                medicine = COMMENT_DATA_MANAGER.updateMedicineListByData(medicine, state.curMedicineItem, params['medicineItem']);
            }
            if(params['medicineContent']) {
                medicine = COMMENT_DATA_MANAGER.updateMedicineListContent(medicine, state.curMedicineItem, params['medicineContent']);
            }
            newParams = Object.assign(newParams, {
                info: JSON.stringify({medicine: JSON.stringify(medicine)})
            })
            // 提交服务器
            API.updatePiPan(newParams, function(data){
                if(data.ret) {

                    // 更新用药数据:用药类型:本地客户端服务器数据+UI数据
                    state.pipanInfo.medicine = JSON.stringify(medicine);
                    state.medicineList = COMMENT_DATA_MANAGER.getMedicineListByList(medicine);

                    // 更新列表数据的批盘状态
                    AppFate.$store.dispatch('record/updateRecordListPipanStatus', state.detailInfo.id);
                    AppFate.$store.dispatch('detail/updateDetailPipanStatus');
                }
            });
        },
        [types.COMMENT_SUBMIT_ADD_PIPAN_MEDICINE](state, medicineData) {
            var medicine = state.pipanInfo.medicine == '' ? [] : JSON.parse(state.pipanInfo.medicine);
            medicine = COMMENT_DATA_MANAGER.addMedicineListData(medicine, medicineData);
            console.log('types.COMMENT_SUBMIT_ADD_PIPAN_MEDICINE-------', medicineData, medicine)
            var newParams = {
                id: state.detailInfo.id,
                info: JSON.stringify({medicine: JSON.stringify(medicine)})
            }
            API.updatePiPan(newParams, function(data){
                if(data.ret) {

                    // 更新用药数据:用药类型:本地客户端服务器数据+UI数据
                    state.pipanInfo.medicine = JSON.stringify(medicine);
                    state.medicineList = COMMENT_DATA_MANAGER.getMedicineListByList(medicine);

                    // 更新列表数据的批盘状态
                    AppFate.$store.dispatch('record/updateRecordListPipanStatus', state.detailInfo.id);
                    AppFate.$store.dispatch('detail/updateDetailPipanStatus');
                }
            });
        },
        [types.COMMENT_SUBMIT_DELETE_PIPAN_MEDICINE](state, medicineData) {
            var medicine = state.pipanInfo.medicine == '' ? [] : JSON.parse(state.pipanInfo.medicine);
            medicine = COMMENT_DATA_MANAGER.deleteMedicineListData(medicine, medicineData);
            console.log('types.COMMENT_SUBMIT_DELETE_PIPAN_MEDICINE-------', medicineData, medicine)
            var newParams = {
                id: state.detailInfo.id,
                info: JSON.stringify({medicine: JSON.stringify(medicine)})
            }
            API.updatePiPan(newParams, function(data){
                if(data.ret) {

                    // 更新用药数据:用药类型:本地客户端服务器数据+UI数据
                    state.pipanInfo.medicine = JSON.stringify(medicine);
                    state.medicineList = COMMENT_DATA_MANAGER.getMedicineListByList(medicine);

                    // 更新列表数据的批盘状态
                    AppFate.$store.dispatch('record/updateRecordListPipanStatus', state.detailInfo.id);
                    AppFate.$store.dispatch('detail/updateDetailPipanStatus');
                }
            });
        },
        [types.COMMENT_SUBMIT_UPDATE_PIPAN_BIG](state, params) {
            console.log('types.COMMENT_SUBMIT_UPDATE_PIPAN_BIG-----', params)
            var dayunLiunianList = [].concat(state.dayunLiunianList);
            var resultData = COMMENT_DATA_MANAGER.getBigParamsByParams(dayunLiunianList, state.pipanInfo.big, params);
            console.log('types.COMMENT_SUBMIT_UPDATE_PIPAN_BIG-----', resultData);
            var newParams = {
                id: state.detailInfo.id,
                info: resultData.infoData
            }
            API.updatePiPan(newParams, function(data){
                if(data.ret) {
                    console.log('更新成功::::::::', data)

                    // 更新本地数据:批盘数据在操作过程中已更新
                    // 更新迷你运盘的数据编辑状态:大运列表数据+流年列表数据
                    var fortuneList = AppFate.$store.state.minifatefortune.fortuneListData;
                    AppFate.$store.state.minifatefortune.fortuneListData = COMMENT_DATA_MANAGER.updateMiniPanDayunListEdited(fortuneList, state.dayunLiunianList);
                    if(params.type == 'liunian') {
                        var liunianList = AppFate.$store.state.minifatefortune.liunianListData;
                        if(liunianList.length > 0) {
                            AppFate.$store.state.minifatefortune.liunianListData = COMMENT_DATA_MANAGER.updateMiniPanLiunianListEdited(liunianList, state.dayunLiunianList, params.parentData)
                        }
                    }

                    // 更新列表数据的批盘状态
                    AppFate.$store.dispatch('record/updateRecordListPipanStatus', state.detailInfo.id);
                    AppFate.$store.dispatch('detail/updateDetailPipanStatus');

                    setTimeout(() => {
                        // 执行回调函数:更新UI层交互
                        if(params.cb && typeof(params.cb) == 'function') {
                            params.cb();
                        }
                    }, 100);
                }
            })
        },
        [types.COMMENT_RESET_DATA](state) {
            state.hideName = false;
            state.canBeEdited = true;
            state.otherSaved = false;
            state.getPiPanData = false;
            state.pipanConfig = {};
            state.pipanInfo = {};
            state.pipanInfoBase = {};
            state.pipanInfoList = {};
            state.shareCode = {};
            state.detailInfo = {};
            state.activeNames = [];
            state.showChange = false;
            state.curChangeType = '';
            state.curChangeList = [];
            state.fateText = '';
            state.situationText = '';
            state.strongText = '';
            state.medicineList = [];
            state.curMedicineItem = {};
            state.showCustom = false;
            state.dayunLiunianList = [];
            state.activeDaYunNames = [];
            state.activeLiuNianNames = [];
            state.curActiveName = '';
            state.curSubTab = 0;
            state.fromMyComment = false;
            state.fromOtherComment = false;
            state.fromCommentFormRead = false;
            state.otherShareTitle = '';
            state.otherShareCode = '';
            state.showBottomBar = true;
        }
    },
    actions: {
        initPiPan({ commit }, params) {
            commit(types.COMMENT_INIT_DATA, params)
        },
        initSharePiPan({ commit }, params) {
            commit(types.COMMENT_INIT_SHARE_DATA, params)
        },
        initOtherPiPan({ commit }, params) {
            commit(types.COMMENT_INIT_OTHER_DATA, params)
        },
        initEmbeddedPiPan({ commit }, params) {
            commit(types.COMMENT_INIT_EMBEDDED_DATA, params)
        },
        updateCommentChangeList({ commit }, type) {
            commit(types.COMMENT_UPDATE_CHANGE_LIST, type)
        },
        updateCommentActiveNames({ commit }, params) {
            commit(types.COMMENT_UPDATE_ACTIVE_NAMES, params)
        },
        updateLiuNianNames({ state }, curName) {
            var curIndex = state.activeLiuNianNames.indexOf(curName);
            if(curIndex == -1) {
                state.activeLiuNianNames.push(curName);
            }else {
                state.activeLiuNianNames.splice(curIndex, 1);
                setTimeout(() => {
                    state.activeLiuNianNames.splice(curIndex, 0, curName);
                }, 20);
            }
        },
        updatePiPan({ commit }, params) {
            commit(types.COMMENT_SUBMIT_UPDATE_PIPAN, params)
        },
        updatePiPanMedicine({ commit }, params) {
            commit(types.COMMENT_SUBMIT_UPDATE_PIPAN_MEDICINE, params)
        },
        addPiPanMedicine({ commit }, medicineData) {
            commit(types.COMMENT_SUBMIT_ADD_PIPAN_MEDICINE, medicineData)
        },
        deletePiPanMedicine({ commit }, medicineData) {
            commit(types.COMMENT_SUBMIT_DELETE_PIPAN_MEDICINE, medicineData)
        },
        updatePiPanBig({ commit }, params) {
            commit(types.COMMENT_SUBMIT_UPDATE_PIPAN_BIG, params)
        },
        resetData({ commit }) {
            commit(types.COMMENT_RESET_DATA);
        }
    }
}